import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const rows = [{
  label: '📘 K-Visual Masterplan™ (6 Bände, 120+ Seiten)',
  price: '19€'
}, {
  label: '🎁 Bonus #1: Hangeul-Turbo-CheatSheet™',
  price: 'KOSTENLOS'
}, {
  label: '🎁 Bonus #2: K-Vokabel-Tracker™',
  price: 'KOSTENLOS'
}, {
  label: '🎁 Bonus #3: K-Reise-Guide™',
  price: 'KOSTENLOS'
}, {
  label: '🎁 Bonus #4: K-Visual Flashcards™',
  price: 'KOSTENLOS'
}, {
  label: '🎁 Bonus #5: Der K-Drama Slang-Spickzettel™',
  price: 'KOSTENLOS'
}, {
  label: '🛡️ Garantie von 7 Tagen',
  price: 'ENTHALTEN'
}, {
  label: '♾️ Lebenslanger Zugriff & Updates',
  price: 'ENTHALTEN'
}];
const trust = [{
  icon: LockIcon,
  label: '100% Sichere Zahlung'
}, {
  icon: ZapIcon,
  label: 'Sofortige Lieferung'
}, {
  icon: ShieldCheckIcon,
  label: '7-Tage-Garantie'
}, {
  icon: CreditCardIcon,
  label: 'Kredit- / Debitkarte'
}];
export function ValueStack() {
  return <section id="value" aria-label="Zusammenfassung des Angebots" className="border-y border-grape/10 bg-white/70" data-id="element-186" data-mp="1tetma2kudrs6">
      <div className="mx-auto max-w-2xl px-5 py-12 text-center" data-id="element-187" data-mp="1ohbdqdaqlekp">
        <h2 className="font-display text-2xl font-black text-plum sm:text-4xl" data-id="element-188" data-mp="234whm9ffrhto">
          📦 Was ist enthalten
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-plum/60" data-id="element-189" data-mp="1ye6e71qklp1m">
          Lies Hangeul, sprich korrekt aus und baue deine ersten echten Sätze auf Koreanisch. Eine
          einmalige Zahlung, lebenslanger Zugriff, alles bereit, um heute zu starten.
        </p>

        <div className="mt-10 overflow-hidden rounded-2xl border border-grape/15 bg-cream text-left" data-id="element-190" data-mp="2m40l72o7kjdy">
          <div className="flex items-center justify-between border-b border-grape/10 px-5 py-3 text-xs font-bold uppercase tracking-wide text-plum/55" data-id="element-191" data-mp="2h4xqab1xztjp">
            <span data-id="element-192" data-mp="rqj7e7dlv0w4">Item</span>
            <span data-id="element-193" data-mp="rrubk8ayqanr">Wert</span>
          </div>
          {rows.map(r => <div key={r.label} className="flex items-center justify-between gap-4 border-b border-grape/10 px-5 py-3.5 text-sm" data-id="element-194" data-mp="ms7xjwnb8qdw">
              <span className="text-plum/80" data-id="element-195" data-mp="2mv8vc8xlpmck">{r.label}</span>
              <span className={r.price.endsWith('€') ? 'shrink-0 font-bold text-plum' : 'shrink-0 font-bold text-grape'} data-id="element-196" data-mp="2rtabakzqd5jt">
                {r.price}
              </span>
            </div>)}
          <div className="flex flex-col items-center gap-1 bg-lilac-soft px-5 py-6 text-center" data-id="element-197" data-mp="30t7674cpr0nb">
            <span className="text-sm font-bold text-plum" style={{
            fontSize: "16px"
          }} data-id="element-198" data-mp="35stklh4a2mxp">
              Gesamtwert: <span className="text-plum/40 line-through" data-id="element-199" data-mp="3aqbhg950tbpc">184€</span>
            </span>
            <span className="text-grape-shine font-display text-5xl font-black leading-none sm:text-6xl" style={{
            fontSize: "64px",
            fontFamily: "Cinzel, serif",
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-200" data-mp="3fhbfxitsg1ty">
              19€
            </span>
            <span className="text-xs font-semibold uppercase tracking-wide text-plum/60" data-id="element-201" data-mp="3ok2uvslvhfqc">
              EUR · Einmalige Zahlung
            </span>
            <span className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-202" data-mp="7fvo82pdl3l0">
              Die Zahlung wird in deiner lokalen Währung abgewickelt.
            </span>
          </div>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-203" data-mp="3tndguktyh3j1">
          <CTAButton data-id="element-204" data-mp="3to52b2tu9kvl">K-Visual Masterplan™ holen — 19€</CTAButton>
        </div>

        <p className="mt-3 text-xs font-semibold text-plum/55" data-id="element-205" data-mp="3pmjn3atu0ui8">
          Einmalige Zahlung · Lebenslanger Zugriff · Du sparst 35€ (65% Rabatt)
        </p>
        

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-206" data-mp="l7jv9rkrp1v4">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-207" data-mp="geh2hlntdwfz">
              <Icon className="h-4 w-4 text-grape" data-id="element-208" data-mp="cezvuownit98" />
              {label}
            </span>)}
        </div>

        <p className="mt-6 text-xs font-semibold text-plum/50" data-id="element-209" data-mp="18z8ulrw0aqlk">
          🔒 100% Sichere Zahlung · ⚡ Sofortiger Zugriff · ♾️ Lebenslanger Zugriff
        </p>
      </div>
    </section>;
}